import React from 'react';
import { BookOpenIcon, BookTextIcon, TabletIcon, HeadphonesIcon } from 'lucide-react';
import { getBookSpineColor } from '../../utils/genreColors';
// Sample indie book metadata structure
export const indieBooksData: Record<string, {
  publisher: string;
  rating: number;
  reviews: number;
  tags: string[];
}> = {
  '1': {
    publisher: 'Indie Press A',
    rating: 4.5,
    reviews: 120,
    tags: ['thriller', 'dark']
  },
  '2': {
    publisher: 'Indie Press A',
    rating: 4.7,
    reviews: 85,
    tags: ['thriller', 'mystery']
  },
  '3': {
    publisher: 'Dark Reads',
    rating: 3.9,
    reviews: 42,
    tags: ['horror', 'ghosts']
  },
  '4': {
    publisher: 'Indie Press B',
    rating: 4.2,
    reviews: 60,
    tags: ['supernatural', 'suspense']
  },
  '5': {
    publisher: 'Fantasy House',
    rating: 4.8,
    reviews: 150,
    tags: ['fantasy', 'romance']
  },
  '6': {
    publisher: 'Fantasy House',
    rating: 4.6,
    reviews: 95,
    tags: ['fantasy', 'romance']
  }
};
// Initial readerBooks with author added
export const initialBooks = [{
  id: '1',
  title: 'The Silent Echo',
  author: 'Elena Richards',
  series: 'Echo Series',
  seriesNumber: 1,
  coverImage: 'https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=800',
  genre: 'Mystery Thriller',
  subgenre: 'Psychological',
  relationshipType: 'Enemies to Lovers',
  triggerWarnings: ['Violence'],
  edition: 'standard',
  releaseDate: '2021-05-15',
  type: 'series',
  status: 'read',
  format: 'paperback',
  dateOwned: '2021-05-20',
  spiceLevel: 3,
  darknessLevel: 4,
  endingType: 'HEA',
  description: 'A gripping thriller that follows detective Sarah Miller as she investigates a series of mysterious disappearances in a small coastal town.'
}, {
  id: '2',
  title: 'Broken Echoes',
  author: 'Elena Richards',
  series: 'Echo Series',
  seriesNumber: 2,
  coverImage: 'https://images.unsplash.com/photo-1589998059171-988d887df646?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=800',
  genre: 'Mystery Thriller',
  subgenre: 'Psychological',
  relationshipType: 'Slow Burn',
  triggerWarnings: ['Violence', 'Death'],
  edition: 'special',
  releaseDate: '2022-01-20',
  type: 'series',
  status: 'currentlyReading',
  format: 'hardcover',
  dateOwned: '2022-01-25',
  spiceLevel: 4,
  darknessLevel: 4,
  endingType: 'Cliffhanger',
  description: 'Detective Sarah Miller returns to face her most challenging case yet as echoes from her past threaten to unravel everything.'
}, {
  id: '3',
  title: 'Whispers in the Dark',
  author: 'Sarah Johnson',
  series: '',
  seriesNumber: null,
  coverImage: 'https://images.unsplash.com/photo-1598646506899-ac6be1060f4b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=800',
  genre: 'Horror',
  subgenre: 'Supernatural',
  relationshipType: 'None',
  triggerWarnings: ['Gore', 'Supernatural Elements'],
  edition: 'standard',
  releaseDate: '2020-10-31',
  type: 'standalone',
  status: 'tbr',
  format: 'ebook',
  dateOwned: '2020-11-15',
  spiceLevel: 2,
  darknessLevel: 5,
  endingType: 'Bittersweet',
  description: 'A chilling tale of supernatural encounters in an abandoned Victorian mansion that has been shunned by locals for generations.'
}, {
  id: '4',
  title: 'Midnight Shadows',
  author: 'Sarah Johnson',
  series: '',
  seriesNumber: null,
  coverImage: 'https://images.unsplash.com/photo-1515876305430-f06edab8282a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=800',
  genre: 'Supernatural Thriller',
  subgenre: 'Paranormal',
  relationshipType: 'Forced Proximity',
  triggerWarnings: ['Violence'],
  edition: 'special',
  releaseDate: '2019-06-15',
  type: 'standalone',
  status: 'dnf',
  format: 'paperback',
  dateOwned: '2019-07-10',
  spiceLevel: 2,
  darknessLevel: 4,
  endingType: 'Bittersweet',
  description: "When strange shadows begin appearing in a small New England town, residents must confront long-buried secrets before it's too late."
}, {
  id: '5',
  title: 'Heart of the Storm',
  author: 'Marcus Chen',
  series: 'Elements Trilogy',
  seriesNumber: 1,
  coverImage: 'https://images.unsplash.com/photo-1516979187457-637abb4f9353?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=800',
  genre: 'Fantasy Romance',
  subgenre: 'Epic Fantasy',
  relationshipType: 'Forbidden Love',
  triggerWarnings: [],
  edition: 'standard',
  releaseDate: '2020-03-22',
  type: 'series',
  status: 'read',
  format: 'paperback',
  dateOwned: '2020-04-01',
  spiceLevel: 4,
  darknessLevel: 3,
  endingType: 'HEA',
  description: 'In a world where elemental magic determines social status, a young woman with extraordinary storm powers must navigate court intrigue and forbidden romance.'
}, {
  id: '6',
  title: 'Soul of Fire',
  author: 'Marcus Chen',
  series: 'Elements Trilogy',
  seriesNumber: 2,
  coverImage: 'https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=800',
  genre: 'Fantasy Romance',
  subgenre: 'Epic Fantasy',
  relationshipType: 'Forbidden Love',
  triggerWarnings: [],
  edition: 'special',
  releaseDate: '2021-01-15',
  type: 'series',
  status: 'currentlyReading',
  format: 'hardcover',
  dateOwned: '2021-01-20',
  spiceLevel: 4,
  darknessLevel: 3,
  endingType: 'HEA',
  description: 'As war looms on the horizon, our heroine must master the fire within her soul while protecting those she loves from mounting dangers.'
}, {
  id: '7',
  title: 'The Lost City',
  author: 'David Williams',
  series: '',
  seriesNumber: null,
  coverImage: 'https://images.unsplash.com/photo-1541963463532-d68292c34b19?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=800',
  genre: 'Adventure',
  subgenre: 'Action',
  relationshipType: 'Friends to Lovers',
  triggerWarnings: [],
  edition: 'standard',
  releaseDate: '2019-03-10',
  type: 'standalone',
  status: 'read',
  format: 'paperback',
  dateOwned: '2019-03-15',
  spiceLevel: 2,
  darknessLevel: 3,
  endingType: 'HEA',
  description: "An archaeologist's discovery of an ancient map leads to a dangerous expedition into the uncharted jungle in search of a legendary lost city."
}, {
  id: '8',
  title: 'Ice Planet Barbarians',
  author: 'Ruby Dixon',
  series: 'Ice Planet Barbarians',
  seriesNumber: 1,
  coverImage: 'https://images.unsplash.com/photo-1518020382113-a7e8fc38eac9?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=800',
  genre: 'Sci-Fi Romance',
  subgenre: 'Alien Romance',
  relationshipType: 'Fated Mates',
  triggerWarnings: ['Sexual Content'],
  edition: 'standard',
  releaseDate: '2015-04-03',
  type: 'series',
  status: 'read',
  format: 'ebook',
  dateOwned: '2021-06-12',
  spiceLevel: 5,
  darknessLevel: 2,
  endingType: 'HEA',
  description: 'Human women abducted from Earth find themselves on an ice planet where they must adapt to survive and unexpectedly find love with the native alien warriors.'
}];
// Complete series data including books not owned
export const completeSeriesData: Record<string, Array<{
  id: string;
  title: string;
  seriesNumber: number;
  coverImage: string;
  owned: boolean;
}>> = {
  'Echo Series': [{
    id: '1',
    title: 'The Silent Echo',
    seriesNumber: 1,
    coverImage: 'https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=800',
    owned: true
  }, {
    id: '2',
    title: 'Broken Echoes',
    seriesNumber: 2,
    coverImage: 'https://images.unsplash.com/photo-1589998059171-988d887df646?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=800',
    owned: true
  }, {
    id: 'echo-3',
    title: 'Final Echo',
    seriesNumber: 3,
    coverImage: 'https://images.unsplash.com/photo-1512820790803-83ca734da794?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=800',
    owned: false
  }],
  'Elements Trilogy': [{
    id: '5',
    title: 'Heart of the Storm',
    seriesNumber: 1,
    coverImage: 'https://images.unsplash.com/photo-1516979187457-637abb4f9353?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=800',
    owned: true
  }, {
    id: '6',
    title: 'Soul of Fire',
    seriesNumber: 2,
    coverImage: 'https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=800',
    owned: true
  }, {
    id: 'elements-3',
    title: 'Breath of Earth',
    seriesNumber: 3,
    coverImage: 'https://images.unsplash.com/photo-1589998059171-988d887df646?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=800',
    owned: false
  }],
  'Dark Chronicles': [{
    id: 'dark-1',
    title: "Shadow's Edge",
    seriesNumber: 1,
    coverImage: 'https://images.unsplash.com/photo-1543002588-bfa74002ed7e?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=800',
    owned: false
  }, {
    id: 'dark-2',
    title: 'Midnight Veil',
    seriesNumber: 2,
    coverImage: 'https://images.unsplash.com/photo-1518020382113-a7e8fc38eac9?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=800',
    owned: false
  }],
  'Ice Planet Barbarians': [{
    id: '8',
    title: 'Ice Planet Barbarians',
    seriesNumber: 1,
    coverImage: 'https://images.unsplash.com/photo-1518020382113-a7e8fc38eac9?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=800',
    owned: true
  }, {
    id: 'ipb-2',
    title: 'Barbarian Alien',
    seriesNumber: 2,
    coverImage: 'https://images.unsplash.com/photo-1543002588-bfa74002ed7e?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=800',
    owned: false
  }]
};
// Status tabs with friendly names
export const tabs = [{
  id: 'read',
  label: 'Read'
}, {
  id: 'currentlyReading',
  label: 'Currently Reading'
}, {
  id: 'tbr',
  label: 'To Be Read'
}, {
  id: 'dnf',
  label: 'Did Not Finish'
}, {
  id: 'ownedShelf',
  label: 'Owned Shelf'
}, {
  id: 'merch',
  label: 'My Collection'
}];
// Genre colors fallback for spine color if no cover
export const genreColors: Record<string, string> = {
  'Mystery Thriller': getBookSpineColor('Mystery'),
  Horror: getBookSpineColor('Horror'),
  'Supernatural Thriller': getBookSpineColor('Thriller'),
  'Fantasy Romance': getBookSpineColor('Fantasy'),
  'Sci-Fi Romance': getBookSpineColor('Science Fiction'),
  Adventure: getBookSpineColor('Adventure'),
  default: getBookSpineColor('default')
};
// Format icons using Lucide components instead of emojis
export const formatIcons: Record<string, React.ReactNode> = {
  paperback: <BookOpenIcon className="h-4 w-4" data-id="element-10900" data-mp="3558ku8wmsqqy" />,
  hardcover: <BookTextIcon className="h-4 w-4" data-id="element-10901" data-mp="309ji5wpbetqf" />,
  ebook: <TabletIcon className="h-4 w-4" data-id="element-10902" data-mp="306nh3zi67oxr" />,
  audiobook: <HeadphonesIcon className="h-4 w-4" data-id="element-10903" data-mp="3eyfui5yemswu" />
};